<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-7 col-12 mb-2">
                <div class="row breadcrumbs-top">
                    <div class="col-12">
                        <h2 class="content-header-title float-left mb-0">PAYE SCHEDULE
                        </h2>
                        <div class="breadcrumb-wrapper col-12">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <router-link to="/home">
                                        {{ trans('general.home') }}
                                    </router-link>
                                </li>
                                <li class="breadcrumb-item active">
                                    NOMINAL ROLL MNGR
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-header-right text-md-right col-md-5 col-12 d-md-block d-none">
                <div class="form-group breadcrum-right">
                    <button class="btn btn-primary btn-sm pull-right" v-if="!showFilterPanel" @click="showFilterPanel = !showFilterPanel"><i class="feather icon-filter"></i> {{trans('general.filter')}}</button>
                    
                </div>
            </div>

        </div>

    <div class="content-body">
        <section id="basic-datatable">
            <div class="row">
                <div class="col-12">

                    <transition name="fade">
                        <div class="card border-bottom" v-if="showFilterPanel">
                            <div class="card-header">
                                <h4 class="mt-2 text-center">PAYE SCHEDULE</h4><br>
                                
                            </div>
                            <div class="card-content">
                                <div class="card-body">
                                    <form @submit.prevent="storePayment" @keydown="paymentForm.errors.clear($event.target.name)">
                                        <div class="row">
                                            <div class="m-2  text- col">
                                                <b class="text-left">Total No.of Staff: {{ staffs.total }}</b>
                                            </div>
                                            <div class="m-2  col">
                                                <b>Total PAYE Per Annum: {{ annualPayee }}</b>
                                            </div>
                                            <div class="m-2  ml-4 col">
                                                <p class="b"><b>Total Monthly PAYE: {{ monthlyPayee }}</b>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="m-1 row">
                                            <div class="col-md-9">
                                                <label class="form-label">Select Month to file</label>
                                                <input name="date" v-model="date" type="month" class="form-control" @input="formatMonth">
                                            </div>
                                            <div class="col-md-3">
                                                <!-- <button-spinner
                                                    :is-loading="paymentForm.isLoading" 
                                                    :disabled="paymentForm.isLoading"
                                                    
                                                    class="btn btn-primary mr-1 mb-1 waves-effect waves-light pull-right"
                                                    style="height: 39px; color: #fff;"
                                                    >
                                                    Generate Invoice
                                                </button-spinner> -->
                                                <button-spinner
                                                    :is-loading="paymentForm.isLoading" 
                                                    :disabled="paymentForm.isLoading"
                                                    
                                                    class="btn btn-primary mr-1 mb-1 waves-effect waves-light pull-right"
                                                    style="height: 39px; color: #fff;"
                                                    >
                                                    Pay now
                                                </button-spinner>
                                                
                                            </div>
                                        </div>
                                    </form>
                            </div>
                            </div>
                        </div>
                    </transition>
                    
                    <div class="card">
                        <div class="card-header">
                            <h4 v-if="staffs.total" class="card-title">
                                <sort-by :order-by-options="orderByOptions" :sort-by="filterStaffForm.sort_by" :order="filterStaffForm.order" @updateSortBy="value => {filterStaffForm.sort_by = value}"  @updateOrder="value => {filterStaffForm.order = value}"></sort-by>
                            </h4>
                        </div>
                        <div class="card-content">
                            <div class="card-body">
                                <div class="table-responsive" v-if="staffs.total">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>{{trans('general.serial_number')}}</th>
                                            <th>ITAS ID</th>
                                            <th>Staff Name</th>
                                            <th>Basic Salary(Month)</th>
                                            <th>Total Income</th>
                                            <th>Gross Salary</th>
                                            <th>Taxable Income</th>
                                            <th>Tax Annually</th>
                                            <th>Tax Monthly</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(staff, index) in staffs.data">
                                            <td v-text="index+1"></td>
                                            <td v-text="staff.itas_id"></td>
                                            <td v-text="staff.name"></td>
                                            <td>{{ staff.earned_basic | formatMoney }}</td>
                                            <td>{{ staff.total_income | formatMoney }}</td>
                                            <td>{{ staff.gross_salary | formatMoney }}</td>
                                            <td>{{ staff.taxable_income | formatMoney }}</td>
                                            <td>{{ staff.tax_annually | formatMoney }}</td>
                                            <td>{{ staff.tax_monthly | formatMoney }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <module-info v-if="!staffs.total" module="staff" title="module_info_title" description="module_info_description" icon="check-circle">
                                <div slot="btn">
                                    <button class="btn btn-primary btn-md" @click="$router.push('/paye/upload')"><i class="feather icon-plus"></i> {{trans('general.add_new')}}</button>
                                </div>
                            </module-info>
                            <pagination-record :page-length.sync="filterStaffForm.page_length" :records="staffs" @updateRecords="getStaffs"></pagination-record>
                             
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
        <div class="modal fade" id="confirmPayment" tabindex="-1" role="dialog" aria-labelledby="paymentDetail" aria-hidden="true" style="display: none;">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title" id="paymentDetail">Payment Confirmation</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body" v-if="showConfirm">
                        <h4>Confirm Payment</h4>
                        <p>Transaction Reference: <strong>{{ reference }}</strong></p>
                        <p>TAX ID: <strong>{{ tax_id }}</strong></p>
                        <p>Phone NO: <strong>{{ paymentForm.phone }}</strong></p>
                        <p>Email: <strong>{{ paymentForm.email }}</strong></p>
                        <p>Year: <strong>{{ paymentForm.payment_year }}</strong></p>
                        <table class="table">
                            <tr>
                                <th>Item</th>
                                <th>Amount</th>
                                <th>Description</th>
                                <th>Month From</th>
                                <th>Month To</th>
                            </tr>
                            <tr>
                                <td>{{ pay_item_name }}</td>
                                <td>{{ paymentForm.amount }}</td>
                                <td>{{ paymentForm.description }}</td>
                                <td>{{ paymentForm.month_from }}</td>
                                <td>{{ paymentForm.month_to }}</td>
                            </tr>
                        </table>
                        <p>Total Amount: <strong>{{ paymentForm.amount }}</strong></p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger waves-effect text-left" data-dismiss="modal">{{trans('general.close')}}</button>
                        <button type="button" class="btn btn-primary waves-effect" @click="generateRRR">Generate RRR</button>
                        <button v-if="paymentForm.gateway_id != 3" type="button" class="btn btn-primary waves-effect" @click="confirmPayment">Confirm</button>

                    </div>
                </div>
            </div>
        </div>
   </div>
    </div>
</template>

<script>
    import sortBy from '../../components/sort-by'
    import dateRangePicker from '../../components/date-range-picker'

    export default {
        components : { sortBy,dateRangePicker },
        data() {
            return {
                paymentForm: new Form({
                    isLoading: false,
                    id: '',
                    user_id: '',
                    tax_office_id: 2,
                    name: '',
                    phone: '',
                    email: '',
                    amount: 2000,
                    gateway_id: 1,
                    payment_year: new Date().getFullYear(),
                    pay_item_id: 149,
                    description: 'Paye org. Private sector',
                    month_from: '',
                    month_to: ''
                }),
                date: new Date().toISOString().slice(0, 7),
                showConfirm: false,
                rrr: '',
                reference: '',
                tax_id: '',
                userRole: '',
                staffs: {
                    total: 0,
                    total_paye_per_anum: 0,
                    data: []
                },
                filterStaffForm: {
                    keyword: '',
                    start_date: '',
                    end_date: '',
                    sort_by : 'created_at',
                    order: 'desc',
                    page_length: helper.getConfig('page_length')
                },
                orderByOptions: [
                    {
                        value: 'itas_id',
                        translation: i18n.staff.itas_id
                    },
                    {
                        value: 'name',
                        translation: i18n.staff.name
                    }
                ],
                showFilterPanel: true
            };
        },
        mounted(){
            this.getStaffs();
            this.userRole = this.getRole()[0];
            this.paymentForm.name = this.getAuthUser('full_name');
            this.paymentForm.phone = this.getAuthUser('phone');
            this.paymentForm.email = this.getAuthUser('email');
        },
        methods: {
            getRole(role){
              return helper.getRole(role);
            },
            hasPermission(permission){
                return helper.hasPermission(permission);
            },
            hasRole(role){
                return helper.hasRole(role);
            },
            getStaffs(page){
                if (typeof page !== 'number') {
                    page = 1;
                }
                let url = helper.getFilterURL(this.filterStaffForm);
                axios.get('/api/staff?page=' + page + url)
                    .then(response => response.data)
                    .then(response => this.staffs = response)
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            formatMonth(event) {
            // Get the selected month value, e.g., "2024-12"
            const [year, month] = event.target.value.split('-');

            // Create a date object using the year and month
            const date = new Date(year, month - 1);

            // Get the month name from the date
            this.paymentForm.month_from = date.toLocaleString('default', { month: 'long' });
            this.paymentForm.month_to = date.toLocaleString('default', { month: 'long' });
            },
            getAuthUser(name){
                return helper.getAuthUser(name);
            },
            storePayment(){
                this.paymentForm.isLoading = true;
                this.paymentForm.amount = this.staffs.total > 0 
                ? this.staffs.data[0].total_monthly_paye
                : 0;
                this.paymentForm.post('/api/payment')
                    .then(response => {
                        this.reference = response.reference;
                        this.tax_id = response.user.tax_id;
                        this.paymentForm.phone = response.user.phone;
                        this.paymentForm.email = response.user.email;
                        this.paymentForm.amount = response.amount;
                        this.paymentForm.pay_item_id = response.pay_item_id;
                        this.paymentForm.description = response.description;
                        this.paymentForm.month_from = response.month_from;
                        this.paymentForm.month_to = response.month_to;
                        this.paymentForm.payment_year = response.payment_year;
                        this.paymentForm.gateway_id = response.gateway_id;
                        this.rrr = response.rrr;
                        this.pay_item_name = response.pay_item.name;
                        if (response.user.virtual_accounts === undefined || response.user.virtual_accounts.length >= 1) {
                            this.bank_name = response.user.virtual_accounts[0].bank_name;
                            this.bank_account_number = response.user.virtual_accounts[0].bank_account_number;
                        }
                        this.paymentForm.isLoading = false;
                        this.showConfirm = true;

                        $('#confirmPayment').modal('show');
                        
                    })
                    .catch(error => {
                        this.paymentForm.isLoading = false;
                        toastr.error(error.message);
                        helper.showErrorMsg(error);
                    });
            },
            generateRRR(){
                $('#confirmPayment').modal('hide');
                window.open('https://login.remita.net/remita/exapp/api/v1/send/api/print/billsvc/biller/' + this.rrr + '/printinvoiceRequest.pdf');
            },
            confirmPayment(){
                $('#confirmPayment').modal('hide');
                if (this.paymentForm.gateway_id == 1) {
                    this.makeRemitaPayment(this.rrr);
                } else {
                    window.location.href = '/payment/' + this.reference + '/print';
                }
            },
            makeRemitaPayment(rrr) {
            var randomnumber = Math.floor(Math.random());
            var paymentEngine = RmPaymentEngine.init({
                key: "QzAwMDAyNzEyNTl8MTEwNjE4NjF8OWZjOWYwNmMyZDk3MDRhYWM3YThiOThlNTNjZTE3ZjYxOTY5NDdmZWE1YzU3NDc0ZjE2ZDZjNTg1YWYxNWY3NWM4ZjMzNzZhNjNhZWZlOWQwNmJhNTFkMjIxYTRiMjYzZDkzNGQ3NTUxNDIxYWNlOGY4ZWEyODY3ZjlhNGUwYTY",
                merchantName: "Sokoto Internal Revenue Services",
                processRrr: true,
                transactionId: randomnumber,
                channel: "CARD,USSD,TRANSFER,BANK,BRANCH,IBANK",
                extendedData: { 
                    customFields: [ 
                        { 
                            name: "rrr", 
                            value: rrr
                        } 
                    ]
                },
                
                onSuccess: function (response) {
                    axios.get('/api/payment/verify/?rrr=' + rrr)
                        .then(response => response.data)
                        .then(response => {
                            if (response.data.message == "Successful") {
                                toastr.success('Payment successful.');
                                //this.$router.push('/payment/' + response.data.orderId);
                                window.location.href = '/payment/' + response.data.orderId + '/print';
                            } else {
                                toastr.error('There is an error.');
                            }
                        })
                        .catch(error => {
                            helper.showDataErrorMsg(error)
                        });
                },
                onError: function (response) {
                    toastr.error(response);
                    console.log('callback Error Response', response);
                },
                onClose: function () {
                    console.log("closed");
                }
            });
                paymentEngine.showPaymentWidget();
        },
        },
        computed: {
            annualPayee() {
            return this.staffs.total > 0 
                ? this.$options.filters.formatMoney(this.staffs.data[0].total_paye_per_annum) 
                : 0;
            },
            monthlyPayee() {
            return this.staffs.total > 0 
                ? this.$options.filters.formatMoney(this.staffs.data[0].total_monthly_paye) 
                : 0;
            }
        },
        filters: {
          momentDateTime(date) {
            return helper.formatDateTime(date);
          },
          formatMoney(value){
            return helper.formatMoney(value);
          }
        },
        watch: {
            filterStaffForm: {
                handler(val){
                    setTimeout(() => {
                        this.getStaffs();
                    }, 500)
                },
                deep: true
            }
        }
    }
</script>
